import React from 'react';

import { Fire, Tools } from '../../../services'
import { Select } from '../../Reusable'

interface Props {
  item: any;
  error?: string;
  disabled?: boolean;

  onChange: (category: string) => void;
}
const SelectAdPro: React.FC<Props> = (props) => {

  const { item } = props

  const [error, setError] = React.useState('')
  const [pros, setPros] = React.useState<any[]>([])
  const [loading, setLoading] = React.useState(false)
  const type = item.type
  
  React.useEffect(() => {
    onFetch().then(setPros)
  }, [])

  const onFetch = async () => {
    setLoading(true)
    try {
      let ref: any = Fire.store().collection('pros')
        .orderBy('createdAt', 'desc')
      const list = await Fire.list(ref)
      for (const item of list) {
        item.label = item.name
        item.value = item.id
      }
      return list
    } catch (err) {
      setError("Impossible de charger les pros")
      console.warn(err)
    }
    setLoading(false)
    return []
  }

  return (
    <div style={{marginBottom: 20}}>
      <div style={{marginBottom: 5}}>Choisir le professionel associé:</div>

      <Select
        disabled={loading}
        value={item.proId || null}
        onChange={(val) => props.onChange(val)}
        options={pros}
      />
    </div>
  );
}

export default SelectAdPro